"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.golf = exports.defaultComponents = exports.breakpoints = void 0;
//
// Define the breakpoints the manifest need to listen to.
//
const breakpoints = exports.breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];

//
// Golf translation ids
//
const golf = exports.golf = {
  login: 'Shared:UtilityBar:AccountTray:SignIn',
  logout: 'Shared:AccountTray:SignOut',
  createAccount: 'Shared:UtilityBar:AccountTray:CreateAccount',
  quickLink: 'Shared:UtilityBar:QuickLinks:Heading',
  controlPanelLinksHeading: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:Heading',
  manageDomains: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageDomains',
  manageWebsiteBuilder: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageWebsiteBuilder',
  manageHosting: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageHosting',
  manageSSLCert: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageSslCertificates',
  inboxLinksHeading: 'Shared:UtilityBar:QuickLinks:InboxLinks:Heading',
  o365Login: 'Shared:UtilityBar:QuickLinks:InboxLinks:O365Login',
  webmailLogin: 'Shared:UtilityBar:QuickLinks:InboxLinks:WebmailLogin',
  proDashboard: 'Shared:UtilityBar:AccountTray:ProDashboard',
  myProducts: 'Shared:UtilityBar:AccountTray:MyProducts',
  products: 'Sales:ProductNav:Products',
  accountSettings: 'Shared:UtilityBar:AccountTray:AccountSettings',
  renewals: 'Shared:UtilityBar:AccountTray:Renewals',
  visitMyAccount: 'Shared:UtilityBar:AccountTray:VisitMyAccount',
  manageAccount: 'Shared:UtilityBar:AccountTray:ManageYourAccount',
  shopperid: 'Shared:UtilityBar:AccountTray:CustomerNumberLabel',
  pinLabel: 'Shared:AccountTray:CustomerPinLabel',
  viewPin: 'Shared:UtilityBar:AccountTray:ViewPin',
  registeredUser: 'Shared:UtilityBar:AccountTray:RegisteredUser',
  signInAccountMessage: 'Shared:UtilityBar:AccountTray:SignInAccountMessage',
  newCustomerHeading: 'Shared:UtilityBar:AccountTray:NewCustomerHeading',
  newCustomerMessage: 'Shared:UtilityBar:AccountTray:NewCustomerMessage',
  createAccountMessage: 'Shared:UtilityBar:AccountTray:CreateAccountMessage',
  allProducts: 'Shared:ProductNav:AllProducts',
  globalDirectory: 'Shared:UtilityBar:SupportPhone:GlobalDirectory',
  globalDirectoryList: 'Shared:UtilityBar:SupportPhone:GlobalDirectory:GlobalDirectoryList',
  contactUs: 'Shared:UtilityBar:SupportPhone:ContactUs',
  showSupportNumbersText: 'Shared:UtilityBar:SupportPhone:ShowSupportNumbersText',
  help: 'Shared:UtilityBar:SupportPhone:HelpCenter:HelpCenterLink',
  helpLink: 'Shared:Help:HeaderLink',
  helpCenter: 'Sales:HelpCenter',
  guideCenter: 'Sales:GuideCenter',
  byGoDaddyGuides: 'Sales:ByGoDaddyGuides',
  noNotificationsTitle: 'Shared:UtilityBar:Notifications:NoNotificationsTitle',
  noNotificationsText: 'Shared:UtilityBar:Notifications:NoNotificationsText',
  failedNotificationsTitle: 'Shared:UtilityBar:Notifications:FailedNotificationsTitle',
  failedNotificationsText: 'Shared:UtilityBar:Notifications:FailedNotificationsText',
  failedNotificationsLink: 'Shared:UtilityBar:Notifications:FailedNotificationsLink',
  notificationsCloseText: 'Shared:UtilityBar:Close',
  notificationsHeaderText: 'Shared:UtilityBar:Notifications:HeaderText',
  notificationsError: 'Shared:UtilityBar:Notifications:NotificationsError',
  blogLink: 'Shared:UtilityBar:BlogLink',
  productPanelControl: 'Sales:ProductPanel:MenuTitle',
  o365LoginEXP: 'Sales:AccountTray:O365Login',
  webmailLoginEXP: 'Sales:AccountTray:WebmailLogin'
};
const defaultComponents = exports.defaultComponents = {
  accountDelegation: true,
  backLink: false,
  marketSelector: true,
  contactTray: true,
  help: true,
  notifications: true,
  accountTray: true,
  cart: true,
  blog: true,
  logo: true,
  utilitySeparator: true,
  domainSearch: false,
  productPanel: false
};